import AdminPage from 'pages/Admin/Component/HeaderSidebar';
import Table from 'pages/Admin/Component/Table';
import ArticleModal from './subViews/ArticleModal';

function ArticleMainView(props) {
    const {
        intl,
        handleEditClick,
        handleDeleteClick,
        handleAddClick,
        openDialog,
        handleCloseDialog,
        handleSubmit,
        initialValues,
        onChangeImage,
        articleData,
        setKeyword,
        keyword,
        isAdd,
        pageSize,
        setPageSize,
        tableData,
        setCurrentPage,
        currentPage,
    } = props;

    return (
        <AdminPage
            header={intl.messages.tableTitle}
            subHeader={`${tableData.count} ${intl.messages.unit}`}
            userName='Admin'
            handleAddClick={handleAddClick}
            onChangeSearch={(e) => setKeyword(e)}
        >
            <Table
                columns={props.columns}
                data={tableData.data}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                keyword={keyword}
                pageSize={pageSize}
                currentPage={currentPage}
                handleChangePageSize={(e) => setPageSize(e)}
                totalPage={tableData.total}
                handleChangeCurrentPage={(e) => setCurrentPage(e)}
            />
            <ArticleModal
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
                intl={intl}
                isAdd={isAdd}
                handleSubmit={handleSubmit}
                initialValues={initialValues}
                data={articleData}
                onChangeImage={onChangeImage}
            />
        </AdminPage>
    );
}

export default ArticleMainView;
